/**
* @module FaceInfo
* @author: zhangyemei
* @description: 人脸识别完善身份证+姓名
* @since: 2020-10-19 16:27:44
*/
import React, { Component } from 'react';
import { Modal, Button, Form, Input, message } from 'antd';
import { updateIdentity } from '@/fetch/api/face.js';
import { getPersonalData } from '@/fetch/api/personal.js';
@Form.create()
export default class FaceInfo extends Component {
  state = {
    faceInfoData: {},
    currentDomain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev-s.yunduoketang.cn'
  };

  componentDidMount() {
    this.getPersonalDataFn();
  }

  getPersonalDataFn = () => {
    getPersonalData({
      domain: this.state.currentDomain
    }).then(res => {
      message.destroy();

      if (res.code == '1') {
        this.setState({
          faceInfoData: res.data || {}
        });
      } else {
        message.error(res.message);
      }
    });
  };
  confirmInfo = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log(999, values);
        updateIdentity(values).then(res => {
          message.destroy();

          if (res.code == '1') {
            this.props.successCallback();
          } else {
            message.error(res.message || '提交失败');
          }
        });
      }
    });
  };

  render() {
    const {
      visible = false,
      successCallback = () => {}
    } = this.props;
    const {
      getFieldDecorator
    } = this.props.form;
    const {
      faceInfoData
    } = this.state; // identityId  name

    return <div data-inspector-line="56" data-inspector-column="6" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx">
        <Modal data-inspector-line="57" data-inspector-column="8" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx" title='完善信息' width={500} centered maskClosable={false} className="protocol-modal" visible={visible} onCancel={successCallback} footer={[<Button data-inspector-line="66" data-inspector-column="12" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx" key="back" onClick={successCallback}>取消</Button>, <Button data-inspector-line="67" data-inspector-column="12" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx" key="submit" type="primary" onClick={this.confirmInfo}>确定</Button>]}>
            <Form data-inspector-line="69" data-inspector-column="12" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx" labelCol={{
          span: 5
        }} wrapperCol={{
          span: 12
        }}>
              <Form.Item data-inspector-line="70" data-inspector-column="14" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx" label="姓名">
                {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: '请输入姓名'
              }, {
                pattern: /^[\u4E00-\u9FA5]{1,5}$/,
                message: '请输入正确的姓名'
              }],
              initialValue: faceInfoData.name
            })(<Input data-inspector-line="74" data-inspector-column="19" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx" placeholder="请输入姓名" />)}
              </Form.Item>
              <Form.Item data-inspector-line="76" data-inspector-column="14" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx" label="身份证">
                {getFieldDecorator('identityId', {
              rules: [{
                required: true,
                message: '请输入身份证号'
              }, {
                pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
                message: '请输入正确的身份证号码'
              }],
              initialValue: faceInfoData.identityId
            })(<Input data-inspector-line="80" data-inspector-column="19" data-inspector-relative-path="src\\components\\FaceModal\\FaceInfo.jsx" placeholder="请输入身份证号" />)}
              </Form.Item>
            </Form>
        </Modal>
      </div>;
  }

}